// extracted by mini-css-extract-plugin
export default {"wrapper":"cPp1FxvNcOIepwTRzsxU","filter":"BvBTvYRKTuzWpxrjmgxG","transactions":"eyC5GdyRqVDuTX4jPHXZ"};